<template>
  <b-modal
    ref="modal"
    :hide-footer="unsavedError"
    :busy="unsavedError"
    hide-header
  >
    <span v-html="errorMessage" />
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      unsavedError: true,
      errorMessage: null
    }
  },

  mounted() {
    this.eventBus.$on('httpError', this.handleError)
  },

  methods: {
    handleError(response) {
      if (response.status) {
        switch (response.status) {
          case 404:
            this.errorMessage = '404: A keresett adat nem található.'
            break
          case 422:
            this.errorMessage = `<ul>${response.data.map(x => `<li>${x.message}</li>`).join()}</ul>`
            this.$store.commit('stopLoader')
            break;
          default:
            this.errorMessage = `${response.status}: ${response.data.error.message}`
        }
      } else {
        this.errorMessage = response
      }
      this.$refs.modal.show()
    }
  },

  inject: ['eventBus']
}
</script>

<style scoped>
.error-message {
  padding: 1em;
}
</style>
